module.exports = __webpack_public_path__ + "img/Ident-1-mobile.05f21984.png";